import React from 'react';
import Component from '@vfuk/core-checkbox-list';
const CheckboxList = props => {
    return React.createElement(Component, Object.assign({}, props));
};
export default CheckboxList;
